// Edit your brand here. This file controls all copy & links across the page.
export const site = {
  brand: "Legacy Studio",
  brandShort: "LS",
  tagline: "Marketing that compounds.",
  intro:
    "A full-stack marketing studio building durable brands — SEO, paid media, social, content, branding, agentic support, and VA operations under one roof.",
  owner: "Mark Cassara",
  email: "Mark@legacystudio.cc",
  phone: "615-956-5996",
  phoneHref: "tel:+16159565996",
  location: "Celina, TX",
  scope: "National operations",
  socials: [
    { label: "Instagram", href: "https://www.instagram.com/markcassara.legacy/" },
    { label: "LinkedIn", href: "https://www.linkedin.com/" },
  ],
};

export const services = [
  {
    no: "01",
    title: "Search (SEO)",
    desc:
      "Technical audits, programmatic content engines and authority links — built to compound.",
    bullets: ["Technical SEO", "Content systems", "Backlinks"],
  },
  {
    no: "02",
    title: "Paid Media",
    desc:
      "Meta, Google, TikTok and YouTube — full-funnel buying with daily creative iteration.",
    bullets: ["Meta + Google", "Creative testing", "Attribution"],
  },
  {
    no: "03",
    title: "Social Media",
    desc:
      "Native, platform-fluent content. Calendars, community management and viral hooks.",
    bullets: ["IG / TikTok", "Community", "Short-form"],
  },
  {
    no: "04",
    title: "Content",
    desc:
      "Editorial, video and lifecycle content that earns trust and turns readers into buyers.",
    bullets: ["Editorial", "Video", "Email"],
  },
  {
    no: "05",
    title: "Branding & Web",
    desc:
      "Identity systems, naming, visual languages and websites that look unmistakable.",
    bullets: ["Identity", "Web", "Systems"],
  },
  {
    no: "06",
    title: "Agentic Support",
    desc:
      "AI-powered customer and tech support agents — trained on your brand voice and SOPs, 24/7.",
    bullets: ["AI agents", "Tech support", "CX automation"],
  },
  {
    no: "07",
    title: "Full-Stack VAs",
    desc:
      "Vetted virtual assistants and project managers embedded into your ops — from inbox to invoicing.",
    bullets: ["Ops VAs", "PMs", "Back-office"],
  },
  {
    no: "08",
    title: "Sustainable Solutions",
    desc:
      "Long-horizon systems, not stunt campaigns — playbooks your team can run after the engagement ends.",
    bullets: ["Playbooks", "SOPs", "Hand-off"],
  },
];

export const work = [
  {
    slug: "morphrentals",
    name: "Morph Rentals",
    industry: "Real Estate / Rentals",
    url: "https://morphrentals.com/",
    instagram: "https://www.instagram.com/morphrentalsny/",
    note: "Brand + booking experience for a NY luxury short-term rental operator.",
    span: "lg:col-span-2 lg:row-span-2",
    img: "/portfolio/morphrentals.png",
  },
  {
    slug: "sbzevents",
    name: "SBZ Events",
    industry: "Events / Hospitality",
    url: "https://www.sbzevents.com/",
    note: "Editorial site and content engine for a high-end events agency.",
    span: "lg:col-span-1 lg:row-span-1",
    img: "/portfolio/sbzevents.png",
  },
  {
    slug: "legacywealthco",
    name: "Legacy Wealth Co.",
    industry: "Finance / Wealth",
    url: "https://legacywealthco.com",
    note: "Authority site and lead pipeline for a multi-vertical wealth firm.",
    span: "lg:col-span-1 lg:row-span-1",
    img: "/portfolio/legacywealthco.png",
  },
  {
    slug: "legacywealthacademy",
    name: "Legacy Wealth Academy",
    industry: "Education / Finance",
    url: "https://legacywealthacademyllc.com/",
    instagram: "https://www.instagram.com/markcassara.legacy/",
    note: "Course funnel + organic growth for Mark Cassara's investing academy.",
    span: "lg:col-span-2 lg:row-span-1",
    img: "/portfolio/legacywealthacademy.png",
  },
  {
    slug: "legacyarmy",
    name: "Legacy Army",
    industry: "Community / Coaching",
    url: "https://legacyarmy.co/",
    note: "Membership platform and content cadence for a private community.",
    span: "lg:col-span-1 lg:row-span-1",
    img: "/portfolio/legacyarmy.png",
  },
  {
    slug: "coretherapies",
    name: "Core Therapies",
    industry: "Healthcare / Therapy",
    url: "https://coretherapies.net/",
    note: "Local SEO + web redesign for a multi-location physical therapy group.",
    span: "lg:col-span-2 lg:row-span-1",
    img: "/portfolio/coretherapies.png",
  },
  {
    slug: "oxygenrt",
    name: "Oxygen RT",
    industry: "Healthcare / Wellness",
    url: "https://oxygenrt.com/",
    note: "Patient-acquisition site for an oxygen therapy practice.",
    span: "lg:col-span-1 lg:row-span-1",
    img: "/portfolio/oxygenrt.png",
  },
  {
    slug: "thebailkingny",
    name: "The Bail King NY",
    industry: "Legal / Services",
    url: "http://www.thebailkingny.com/",
    note: "Conversion-first site for a 24/7 NY bail bonds operator.",
    span: "lg:col-span-1 lg:row-span-1",
    img: "/portfolio/thebailkingny.png",
  },
  {
    slug: "hbotusa",
    name: "HBOT USA",
    industry: "Healthcare / Hyperbaric",
    url: "https://hbotusa.com/",
    instagram: "https://www.instagram.com/hbotusa/",
    note: "National brand + lead system for hyperbaric oxygen clinics.",
    span: "lg:col-span-2 lg:row-span-1",
    img: "/portfolio/hbotusa.png",
  },
];

export const process = [
  {
    no: "01",
    title: "Discover",
    desc:
      "Audit existing assets, customers, channels and funnel. Define the unfair advantage.",
  },
  {
    no: "02",
    title: "Strategy",
    desc:
      "Positioning, offer, channel mix and a 90-day roadmap with measurable bets.",
  },
  {
    no: "03",
    title: "Execute",
    desc:
      "Daily content, creative testing, technical SEO and weekly performance reviews.",
  },
  {
    no: "04",
    title: "Scale",
    desc:
      "Double down on winners, build proprietary systems, and compound the brand.",
  },
];

export const stats = [
  { value: "100", suffix: "+", label: "Clients served" },
  { value: "47", suffix: "M", label: "Impressions earned" },
  { value: "3.8", suffix: "x", label: "Avg. ROAS" },
  { value: "12", suffix: "yrs", label: "Combined experience" },
];

export const marqueeWords = [
  "MORPH RENTALS",
  "SBZ EVENTS",
  "LEGACY WEALTH",
  "LEGACY ARMY",
  "CORE THERAPIES",
  "OXYGEN RT",
  "THE BAIL KING",
  "HBOT USA",
  "WEALTH ACADEMY",
];
